import { useEffect } from 'react';
import { useFieldArray, Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import TemplateBodyField from '../../components/template-body-field';
import ProductCard from './Product-Carousel-card';
import styles from '../../stylesheets/marketingProductCarousel.module.css';
import { Button } from 'primereact/button';
import { ReactComponent as StarIcon } from '../../../../../assets/svgIcons/star.svg';
import SelectCards from '../../components/Select-cards';

const productCTAOptions = [
  {
    label: 'Fixed "View"',
    value: 'VIEW',
    description: 'Opens Product Detail in Skaletbot. Default and Recommended.',
  },
  {
    label: 'Custom URL',
    value: 'CUSTOM',
    description: 'Redirect to an external page — Landing Page, Store, etc.',
  },
];

const ProductCarouselEditor = ({
  control,
  watch,
  setValue,

  textAreaRef,
  getFormErrorMessage,
  SPAM_SUGGESTIONS,
  showSpamSuggestions,
  setShowSpamSuggestions,
  checkForSpam,
  messsageVariables,
  menuRef,

  showEmoji,
  setShowEmoji,
  handleEmojiClick,

  tempVariables,
  handleEditVariable,
  handleDeleteVariable,
  watchContent,
}) => {
  const ctaType = watch('productCTAType');

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'productCards',
  });

  const addCard = () => {
    if (fields.length >= 10) return;

    append({
      productId: null,
    });
  };

  useEffect(() => {
    if (fields.length === 0) {
      addCard();
    }
  }, []);

  return (
    <>
      {/* BODY */}

      <TemplateBodyField
        control={control}
        textAreaRef={textAreaRef}
        getFormErrorMessage={getFormErrorMessage}
        SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
        showSpamSuggestions={showSpamSuggestions}
        setShowSpamSuggestions={setShowSpamSuggestions}
        checkForSpam={checkForSpam}
        messsageVariables={messsageVariables}
        menuRef={menuRef}
        showEmoji={showEmoji}
        setShowEmoji={setShowEmoji}
        handleEmojiClick={handleEmojiClick}
        tempVariables={tempVariables}
        handleEditVariable={handleEditVariable}
        handleDeleteVariable={handleDeleteVariable}
        watchContent={watchContent}
      />

      {/* CTA BUTTON SECTION */}

      <div className="mt-4">
        <label className="form-label">CTA button — applies to all cards</label>

        <SelectCards
          control={control}
          name="productCTAType"
          options={productCTAOptions}
          defaultValue="VIEW"
        />

        {/* CUSTOM URL INPUT */}

        {ctaType === 'CUSTOM' && (
          <div className={styles.urlBox}>
            <div className={styles.urlRow}>
              <Controller
                name="productCTA.text"
                control={control}
                render={({ field }) => (
                  <InputText {...field} placeholder="Visit Site" className={styles.input} />
                )}
              />

              <Controller
                name="productCTA.url"
                control={control}
                render={({ field }) => (
                  <InputText
                    {...field}
                    placeholder="https://www.example.com"
                    className={styles.input}
                  />
                )}
              />
            </div>
          </div>
        )}

        <p className="text-sm text-color-secondary mt-2">
          All product cards share the same CTA type. Choose once and it will apply to every card.
        </p>
      </div>

      {/* PRODUCT CARDS */}

      <div className="mt-4">
        <h3>Cards</h3>
        <div className="flex flex-column gap-2">
          {fields.map((card, index) => (
            <ProductCard
              key={card.id}
              index={index}
              control={control}
              removeCard={remove}
              watch={watch}
            />
          ))}
        </div>

        {fields.length < 10 && (
          <div className="mt-3 w-full">
            <Button type="button" className={styles.addCardBtn} onClick={addCard}>
              <span>
                {' '}
                <StarIcon /> Add Card{' '}
              </span>
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductCarouselEditor;
